import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { AppButton } from "site/ui";

// Styled components
const DropdownContainerDiv = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownMenuDiv = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
  min-width: 180px;
  overflow: hidden;
`;

const DropdownItemDiv = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  font-family: "Manrope", sans-serif;
  font-size: 14px;
  color: #333;
  transition: background 0.2s ease;

  &:hover {
    background: #f5f8ff;
  }
`;

// Component definition
interface ExportButtonProps {}

export const ExportButton: React.FC<ExportButtonProps> = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Handle download actions
  const handleDownload = (format: "CSV" | "EXCEL" | "PDF"): void => {
    // Implement actual download logic here
    console.log(`Downloading as ${format}`);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <DropdownContainerDiv ref={dropdownRef}>
      <AppButton variant="primary" onClick={(): void => setIsOpen(!isOpen)}>
        Export
      </AppButton>

      {isOpen && (
        <DropdownMenuDiv>
          <DropdownItemDiv onClick={(): void => handleDownload("CSV")}>
            Download as CSV
          </DropdownItemDiv>
          <DropdownItemDiv onClick={(): void => handleDownload("EXCEL")}>
            Download as EXCEL
          </DropdownItemDiv>
          <DropdownItemDiv onClick={(): void => handleDownload("PDF")}>
            Download as PDF
          </DropdownItemDiv>
        </DropdownMenuDiv>
      )}
    </DropdownContainerDiv>
  );
};
